import { render, staticRenderFns } from "./FunnelChartSchool2.vue?vue&type=template&id=fa8468f6&scoped=true&"
import script from "./FunnelChartSchool2.vue?vue&type=script&lang=js&"
export * from "./FunnelChartSchool2.vue?vue&type=script&lang=js&"
import style0 from "./FunnelChartSchool2.vue?vue&type=style&index=0&id=fa8468f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa8468f6",
  null
  
)

export default component.exports